import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  textItem: {
    color: Theme.palette.gray[800],
    fontSize: Theme.typography.size[0],
    lineHeight: 'normal',
    [Theme.breakpoints.up('md')]: {
      fontSize: Theme.typography.size[1],
    },
  },
  interactiveItem: {
    cursor: 'pointer',
    color: Theme.palette.primary.light,
    '&:hover': {
      color: Theme.palette.primary.main,
    },
  },
  currentPage: {
    color: Theme.palette.primary.main,
    fontWeight: '600',
  },
}));

export default useStyles;
